import { createContext, useState, useEffect } from "react";
// import useLocalStorage from "../hooks/useLocalStorage";
import { AuthContextType } from "../types/contexts/AuthContext";
import useLocalStorage from "../hooks/useLocalStorage";
import { refreshTokens } from "../api/interceptors";
import axiosInstance from "../api/axiosConfig";
import {
  login,
  logout,
} from "../features/authentication/login-page/login-page.service";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { verifyOtp } from "../features/authentication/verify-otp-page/verify-otp-page.service";

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  isLoading: false,
  updateAuthentication: () => {},
  updateLoading: () => {},
  handleLogout: () => {},
  handleLogin: () => {},
  handleVerifyOtp: () => {},
  user: {},
});

const AuthProvider: any = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [refreshToken, setRefreshToken] = useLocalStorage("refreshToken");
  const [isLoading, setIsLoading] = useState<boolean>(true); // Set initial value to true
  const [user, setUser] = useState<any>({});
  const navigate = useNavigate();

  const updateAuthentication = (authenticated: any) => {
    setIsAuthenticated(authenticated);
    setIsLoading(false);
  };

  const handleLogout = async () => {
    await logout(refreshToken);
    localStorage.clear();
    setIsAuthenticated(false);
    setIsLoading(false);
  };

  const updateLoading = (isLoading: boolean) => {
    setIsLoading(isLoading);
  };

  const handleLogin = async (values: any) => {
    try {
      const response = await login(values);
      if (response.data.isMultiFactorAuthenticationEnabled) {
        localStorage.setItem("userId", response.data.user._id);
        navigate("/verify-otp");
      }
      if (response.data) {
        localStorage.setItem("token", response.data.tokens.access.token);
        localStorage.setItem(
          "refreshToken",
          response.data.tokens.refresh.token
        );
        localStorage.setItem("userId", response.data.user._id);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(response.data.user);
        setIsAuthenticated(true);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  const handleVerifyOtp = async (values: any) => {
    try {
      const response = await verifyOtp({
        ...values,
        userId: localStorage.getItem("userId"),
      });
      if (response.data) {
        localStorage.setItem("token", response.data.tokens.access.token);
        localStorage.setItem(
          "refreshToken",
          response.data.tokens.refresh.token
        );
        localStorage.setItem("userId", response.data.user._id);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(response.data.user);
        setIsAuthenticated(true);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    if (refreshToken) {
      refreshTokens(axiosInstance)
        .then((response) => {
          setRefreshToken(response.data.tokens.refresh.token);
          setIsAuthenticated(true);
          setIsLoading(false);
          setUser(response.data.user);
        })
        .catch(() => {
          handleLogout();
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        isLoading,
        updateAuthentication,
        updateLoading,
        handleLogout,
        handleLogin,
        handleVerifyOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
